import { Component, computed, HostListener, input, OnDestroy, output, signal } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

let nextUniqueDataCy = 0;

@Component({
  selector: 'accredible-checkbox-input',
  templateUrl: './checkbox-input.component.html',
  styleUrls: ['./checkbox-input.component.scss'],
  // We are not using ChangeDetectionStrategy.OnPush because this input component
  // does not detect changes when formGroup.markAllAsTouched() is triggered
})
export class AccredibleCheckboxInputComponent implements OnDestroy {
  formControlRef = input<UntypedFormControl>();
  checked = input(false);
  label = input<string>();
  required = input(false);
  hint = input<string>();
  disabled = input(false);
  dataCy = input<string>(`checkbox-${nextUniqueDataCy++}`);
  color = input<'light-primary' | 'light-secondary' | 'default'>('default');

  checkboxChange = output<boolean>();

  state = computed(() => {
    return {
      checked: signal(this.formControlRef()?.value || this.checked()),
    };
  });

  @HostListener('click')
  onClick(): boolean {
    return !this.disabled();
  }

  onChange(event: Event): void {
    event.stopPropagation();
    this.state().checked.set(!this.state().checked());
    this.checkboxChange.emit(this.state().checked());
  }

  ngOnDestroy(): void {
    nextUniqueDataCy = 0;
  }
}
